import React from "react";
import "./Background.css";
import { Projects } from "../../components";
export const Background = () => {
  return (
    <div className="gpt3__projectsContainer">
      <Projects />
    </div>
  );
};
